import { render, staticRenderFns } from "./comImg.vue?vue&type=template&id=40cac835&scoped=true&"
import script from "./comImg.vue?vue&type=script&lang=js&"
export * from "./comImg.vue?vue&type=script&lang=js&"
import style0 from "./comImg.vue?vue&type=style&index=0&id=40cac835&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cac835",
  null
  
)

export default component.exports